<template>
	<div>
		<div class="columns">
			<div
				v-if="
					filtered_products.length == 0 && loaded == true && term !== ''
				"
				class="column is-full has-text-centered">
				<span class="is-size-4">{{ no_filter_message }}</span>
			</div>
			<div
				v-if="filtered_products.length == 0 && loaded == true && term == ''"
				class="column is-full has-text-centered">
				<span class="is-size-4">{{ no_product_message }}</span>
			</div>
		</div>
		<!-- PRODUCT CARDS START -->
		<div class="columns is-mobile is-multiline margin-auto">
			<div
				:key="product.name + product.id"
				v-for="(product, index) in filtered_products"
				class="column px-1-mobile is-one-fifth-desktop is-one-third-tablet is-half-mobile"
				style="align-items: stretch; display: flex">
				<!--  -->
				<div class="card width-100">
					<div class="card-image">
						<figure class="image is-square">
							<a
								:href="
									origin + '/@' + product.shop_slug + '/' + product.id
								">
								<img
									:src="product.images[0]"
									:key="product.name + product.id + 'image'"
									:alt="product.name"
									style="object-fit: cover" />
							</a>
						</figure>
					</div>
					<div class="card-content pt-2 pb-2 pl-3 pr-3">
						<div class="content has-text-centered">
							<p
								class="is-size-6 mt-3 mb-0"
								style="
									text-overflow: ellipsis;
									overflow: hidden;
									white-space: nowrap;
								">
								<a
									:href="
										origin +
										'/@' +
										product.shop_slug +
										'/' +
										product.id
									"
									>{{ product.name }}</a
								>
							</p>
							<p class="mt-2 has-text-weight-bold">
								<span class="is-block is-size-6">{{
									price(product.pricing)
								}}</span>
								<span
									class="tag is-light is-size-6 mt-4 mb-1 has-text-weight-normal"
									style="border: none">
									<span class="is-size-6">
										{{ pricingModelEmoji(product.model) }}
									</span>
									<span class="is-size-7">
										{{ "&nbsp;" + product.model }}
									</span>
								</span>
							</p>
						</div>
					</div>
				</div>
				<!--  -->
			</div>
		</div>
		<!-- PRODUCT CARDS STOP -->
	</div>
</template>
<style type="text/css" scoped=""></style>
<script type="text/javascript">
	export default {
		data: function () {
			return {
				filtered_products: this.$store.getters.filtered_products,
				loaded: this.$store.getters.has_loaded,
				term: this.$store.getters.term,
				state_varaible: this.$store.state,
			};
		},
		mounted() {
			let _this = this;
		},
		computed: {
			products: function () {
				return this.$store.state.products;
			},
			origin: function () {
				return this.$store.state.origin;
			},
			no_filter_message: function () {
				let _this = this;
				return `No Product Matches: ${_this.term}`;
			},
			no_product_message: function () {
				return "There are no products in this store";
			},
		},
		watch: {
			state_varaible: {
				deep: true,
				handler(newValue, oldValue) {
					let _this = this;
					_this.filtered_products = _this.$store.getters.filtered_products;
					_this.loaded = _this.$store.getters.has_loaded;
					_this.term = _this.$store.getters.term;
				},
			},
		},
		methods: {
			price: function (obj) {
				let t = this;
				if (obj.current > 0) {
					return `${Intl.NumberFormat("en-US", {
						style: "currency",
						currency: "USD",
					}).format(obj.current)} ${obj.currency}`;
				} else if (obj.current == 0) {
					return "FREE";
				} else if (obj.current == -1 || obj.current < 0) {
					return "NEGOTIABLE";
				}
			},
			pricingModelEmoji(pricing_model) {
				switch (pricing_model) {
					case "Single-Payment":
						return "💵";
					case "Subscription":
						return "🎟";
					case "Negotiate":
						return "🤝";
					case "Auction":
						return "👨🏽‍⚖️";
				}
				return "";
			},
			currency_symbol(obj) {
				if (obj.currency == "JMD" || obj.currency == "USD") {
					return "$";
				}
			},
		},
	};
</script>
